import { LOGO_URL } from "@/config/site";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-brand-bg2 py-16 sm:py-24 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block font-subheading font-bold uppercase tracking-[0.3em] text-brand-orange text-xs mb-4">
              About Us
            </span>
            <h2 className="font-heading text-5xl sm:text-7xl text-white uppercase tracking-tight leading-none">
              Two cuisines. <br />
              <span className="text-brand-orange">One obsession.</span>
            </h2>

            <div className="mt-6 space-y-4 font-body text-white/75 leading-relaxed text-base sm:text-lg">
              <p>
                Smashed Burger &amp; Bao Boy was born in Hove out of one simple idea: take the
                two things we couldn't stop eating — proper smashed-patty cheeseburgers and
                fluffy Asian baos — and serve them under one roof, done properly.
              </p>
              <p>
                Every burger is hand-formed and smashed to order on a screaming hot flat-top
                for that signature crust. Every bao is steamed fresh and stuffed with proteins
                we glaze in-house — hoisin beef, Korean fire chicken, hot-honey halloumi.
              </p>
              <p>
                No shortcuts. No frozen patties. No microwaves. Just big, honest street-food
                flavour built fresh whenever you order.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
              <div data-testid="about-stat-fresh">
                <div className="font-heading text-4xl sm:text-5xl text-brand-orange leading-none">100%</div>
                <div className="mt-1 font-subheading font-semibold uppercase tracking-widest text-white/60 text-[10px] sm:text-xs">
                  Fresh, never frozen
                </div>
              </div>
              <div data-testid="about-stat-house">
                <div className="font-heading text-4xl sm:text-5xl text-brand-green leading-none">In-House</div>
                <div className="mt-1 font-subheading font-semibold uppercase tracking-widest text-white/60 text-[10px] sm:text-xs">
                  Sauces &amp; glazes
                </div>
              </div>
              <div data-testid="about-stat-local">
                <div className="font-heading text-4xl sm:text-5xl text-brand-teal leading-none">Hove</div>
                <div className="mt-1 font-subheading font-semibold uppercase tracking-widest text-white/60 text-[10px] sm:text-xs">
                  Proudly local
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 flex justify-center">
            <div className="relative">
              <div className="absolute -inset-8 bg-brand-orange/20 blur-3xl rounded-full" />
              <img
                src={LOGO_URL}
                alt="Smashed Burger & Bao Boy logo"
                className="relative w-72 sm:w-96 lg:w-[28rem] h-auto"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
